
import { mapGetters } from 'vuex'
import _ from 'lodash'
import { getBaseUrl } from '~/config/api'
import ui from '~/ZenOne-StoryBook/mixins/ui'
import DistributorConnectCard from '~/components/ConnectDistributors/DistributorConnectCard/index.vue'

export default {
  name: 'RegistrationStepFour',
  components: {
    DistributorConnectCard,
  },
  mixins: [ui],
  props: {},
  data() {
    return {
      externalError: '',
      searchTerm: '',
      distributors: [],
      filteredDistributors: [],
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
      getDistributorSocket: 'distributors/getDistributor'
    })
  },
  watch: {
    getDistributorSocket(v) {
      const index = _.findIndex(
        this.distributors,
        (el) => parseInt(el.id) === parseInt(v.distributor_id)
      )
      if (index !== -1) {
        this.distributors[index].status = v.status
        this.distributors[index].note = v.note
        this.onSearch(this.searchTerm)
      }
    },
  },
  async created() {
    await this.fetchDistributors()
  },
  methods: {
    reset(e) {
      this.onSearch('')
      e.target.value = ''
    },
    onSearch(v) {
      if (!v) {
        this.filteredDistributors = this.distributors
      } else {
        this.filteredDistributors = this.distributors.filter(d => d.searchToken.includes(v.toLowerCase()))
      }
    },
    async fetchDistributors() {
      try {
        this.showFSLoader()

        const res = await this.$axios.get(`${getBaseUrl()}/api/v2/distributors/list-for-wizard`)

        this.distributors = res.data
        this.onSearch(this.searchTerm)
      } catch (e) {
        console.error('onConfirm', e)
      } finally {
        this.hideFSLoader()
      }
    },
    nextBtnClickHandler() {
      return true
    }
  }
}
